<!-- Header row: menu title (single-menu only, no back button — layout header handles that) -->
<div *ngIf="menuTitle" class="relative flex items-center px-4 h-10 border-b border-gray-200 dark:border-zinc-700">
    <span class="font-semibold text-lg dark:text-zinc-100 truncate">{{ menuTitle }}</span>
    <div *ngIf="showSearch" class="ms-auto flex-shrink-0">
        <search [appearance]="'bar'"></search>
    </div>
</div>

<!-- Chips row: horizontal scrolling category chips -->
<div appDragScroll
     #chipsContainer
     class="w-full max-w-full overflow-x-auto scrollbar-hide bg-white dark:bg-zinc-900">
    <div class="flex items-center gap-2 py-2 whitespace-nowrap ps-4 w-max">
        <button
            *ngFor="let category of categories"
            [attr.id]="category.uuid + '-chip'"
            class="px-3.5 py-1 rounded-full text-sm font-medium transition-all duration-300 ease-in-out flex-shrink-0 focus:outline-none border"
            [ngClass]="{'bg-zinc-800 dark:bg-zinc-100 text-white dark:text-zinc-900 border-zinc-800 dark:border-zinc-100': selectedCategoryUuid === category.uuid, 'bg-transparent text-zinc-800 dark:text-zinc-200 border-zinc-300 dark:border-zinc-600 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedCategoryUuid !== category.uuid}"
            (click)="onChipClick(category.uuid)">
            {{ getCategoryName(category) }}
        </button>
        <div class="flex-shrink-0 w-2" aria-hidden="true"></div>
    </div>
</div>
